import KibanaLogger from '@xfinity/kibanajs';
import flags, { flagEnabled } from './featureFlags';

let guid = '';

const kibana = KibanaLogger.initialize({
  component: 'maw_devices',
  sessionID: (window.MAW && window.MAW.sessionID) ? window.MAW.sessionID : 'unknown',
});

export const setGuid = (currentGuid) => {
  guid = currentGuid;
};

// --- DEBUG: expose current guid for temporary gating logs (remove with debug logging) ---
export const getGuid = () => guid;

let kibanaEnabled;

const whenReady = (fn) => {
  if (kibanaEnabled === false) {
    return;
  }
  if (kibanaEnabled) {
    fn();
    return;
  }
  // kibanaEnabled hasn't been set yet (e.g., === undefined, not false);
  //  delay run of `fn` until it is.
  flags.onReady(() => {
    kibanaEnabled = flagEnabled('kibana.enabled') && flagEnabled('global.kibana.enabled');
    whenReady(fn);
  });
};

export const kibanaLog = (en, data = {}) => whenReady(() => {
  kibana.log(en, { ...data, guid });
});

export const kibanaErrorLog = (data = {}) => whenReady(() => {
  kibana.errorLog({ ...data, guid });
});

export const kibanaServiceLog = (data = {}) => whenReady(() => {
  kibana.serviceLog({ ...data, guid });
});

const stacktraceFromException = errorObj => errorObj.stack
                                            || errorObj.backtrace
                                            || errorObj.stacktrace;

function generateStacktrace() {
  let generated;
  let stacktrace;

  const MAX_FAKE_STACK_SIZE = 10;
  const ANONYMOUS_FUNCTION_PLACEHOLDER = '[anonymous]';
  const FUNCTION_REGEX = /function\s*([\w\-$]+)?\s*\(/i;

  // Try to generate a real stacktrace (most browsers, except IE9 and below).
  try {
    throw new Error('');
  } catch (exception) {
    generated = '<generated>';
    stacktrace = stacktraceFromException(exception);
  }

  // Otherwise, build a fake stacktrace from the list of method names by
  // looping through the list of functions that called this one (and skip
  // whoever called us).
  if (!stacktrace) {
    generated = '<generated-ie>';
    let functionStack = [];
    try {
      // eslint-disable-next-line no-caller, no-restricted-properties
      let curr = arguments.callee.caller.caller;
      while (curr && functionStack.length < MAX_FAKE_STACK_SIZE) {
        const fn = FUNCTION_REGEX.test(curr.toString())
          ? (RegExp.$1 || ANONYMOUS_FUNCTION_PLACEHOLDER)
          : ANONYMOUS_FUNCTION_PLACEHOLDER;
        functionStack.push(fn);
        curr = curr.caller;
      }
    } catch (e) {
      functionStack = e;
    }
    stacktrace = functionStack.join('|');
  }
  return generated + stacktrace;
}

window.onerror = (errorMsg, url, lineNumber, column, errorObj) => {
  const data = {
    name: (errorObj && errorObj.name) || 'window.onerror',
    stacktrace: (errorObj && stacktraceFromException(errorObj)) || generateStacktrace(),
  };

  if (errorMsg) {
    data.error_message = errorMsg;
  }

  if (url) {
    data.script = url;
  }

  if (lineNumber) {
    data.line = lineNumber;
  }

  if (column) {
    data.column = column;
  }

  kibanaErrorLog('js_error', data);
};
